import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAppConfig } from '../models/app-config.model';
@Injectable({
    providedIn: 'root'
})
export class AppConfig {
    static config: IAppConfig;
    constructor(
    ) {
    }
    static setConfig(config: IAppConfig) {
        config.oAuthConfig.post_logout_redirect_uri = window.location.origin;
        config.oAuthConfig.redirect_uri = window.location.origin + config.oAuthConfig.redirect_uri;
        config.oAuthConfig.silent_redirect_uri = window.location.origin + config.oAuthConfig.silent_redirect_uri;
        this.config = config;
    }
    static getConfig(): IAppConfig {
        return this.config;
    }
}